export function topicSwitcher() {
  return {
    selectedTopicId: null,
    emptyForm: null,

    init() {
      this.emptyForm = this.$refs.emptyForm.cloneNode(true);
      this.$watch('selectedTopicId', (value) => {
        if (!value) {
          document.querySelector('#topic_switcher_entry_form').replaceChildren(this.emptyForm);
        } else {
          this.$refs.topicSelectForm.requestSubmit();
        }
      });
    },
  };
}
